const Banner = ({ imgSrc, href  }) => {
  return (
    <div className="w-full h-[10%] relative text-center overflow-hidden border border-black rounded ">
      {imgSrc && (
        <a href={href || "#"} target="_blank" rel="noopener noreferrer">
        <img
          src={imgSrc}
          alt={"배너 이미지"}
          className="w-full h-full object-cover"
        />
      </a>
      )}
    </div>
  );
};

export default Banner;
